import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-twenty-four',
  templateUrl: './home-twenty-four.component.html',
  styleUrls: ['./home-twenty-four.component.scss']
})
export class HomeTwentyFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
